




































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import ModalDelete from '@/app/ui/components/ModalDelete/index'
import ModalImage from '@/app/ui/components/ImageGallery/index.vue'
import ImageSelect from '@/app/ui/components/SelectImage/index.vue'
import { trainingMaterialDataModule } from '@/app/store/modules/trainingMaterial'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { defaultImage } from '@/utils/default'

@Component({
  components: {
    'modal-delete': ModalDelete,
    'modal-image': ModalImage,
    'image-select': ImageSelect,
    'date-picker': DatePicker,
  },
})
export default class extends Vue {
  @Prop({}) public dataTable
  @Prop({}) public onPageLimit
  @Prop({}) public onPageNumChanged
  @Prop({}) public fields
  @Prop({}) public selected
  @Prop({}) public isLoading
  @Prop({}) public imageDataCategory
  @Prop({}) public clearTableStatus

  @Watch('clearTableStatus')
  public onPropertyChanged(value: boolean, oldValue: boolean) {
    this.$refs.selectableTable.clearSelected()
  }
  public disableDate(date) {
    return date < new Date()
  }
  public get isFilledDataTable() {
    return (
      this.dataTable !== undefined && this.dataTable.pagination !== undefined
    )
  }

  // Form Edit
  public dateTimeexpired: string = ''
  public freeText1: string = ''
  public freeText2: string = ''
  public id: number = 0
  public title: string = ''
  public get stateExpiredDate() {
    return this.dateTimeexpired !== null ? true : false
  }
  public get stateTitle() {
    return this.title.length >= 4 ? true : false
  }
  public get stateFreeText1() {
    return this.freeText1.length >= 2 ? true : false
  }
  public get stateFreeText2() {
    return this.freeText2.length >= 2 ? true : false
  }
  public isRecommended: boolean = true
  public imageThumbnailId: any = {
    id: null,
    link: defaultImage,
  }
  public hasFiles = {
    fileName: '',
    fileByte: '',
    fileUpload: null,
  }
  public files = {}

  public funcEdit(item, index, button) {
    // console.log('item', item.expireddate)
    if (this.$props.selected.length < 1) {
      this.freeText1 = item.file.code.split('-')[0]
      this.freeText2 = item.file.code.split('-')[1]
      this.id = item.id
      this.title = item.title
      this.isRecommended = item.isRecommended
      this.files = item.file
      this.imageThumbnailId.id = item.imageThumbnail.image_id
      this.imageThumbnailId.link = item.imageThumbnail.link
      this.dateTimeexpired = item.expireddate
      this.$root.$emit('bv::show::modal', this.postInfo.id, button)
    }
  }

  public onPaste(evt) {
    return evt.preventDefault()
  }

  // // validate input sales-code
  // // Using @@keypress="freeText1Press($event)" in html
  // public freeText1Press(evt) {
  //   evt = evt ? evt : window.event
  //   const charCode = evt.which ? evt.which : evt.keyCode
  //   if (this.freeText1.length > 4) {
  //     evt.preventDefault()
  //   } else {
  //     return true
  //   }
  // }
  // public freeText2Press(evt) {
  //   evt = evt ? evt : window.event
  //   const charCode = evt.which ? evt.which : evt.keyCode
  //   if (this.freeText2.length > 4) {
  //     evt.preventDefault()
  //   } else {
  //     return true
  //   }
  // }
  // public monthPress(evt) {
  //   evt = evt ? evt : window.event
  //   const charCode = evt.which ? evt.which : evt.keyCode
  //   if (
  //     this.month.length > 1 ||
  //     (charCode > 31 && (charCode < 48 || charCode > 57))
  //   ) {
  //     evt.preventDefault()
  //   } else {
  //     return true
  //   }
  // }
  // public yearPress(evt) {
  //   evt = evt ? evt : window.event
  //   const charCode = evt.which ? evt.which : evt.keyCode
  //   if (
  //     this.year.length > 3 ||
  //     (charCode > 31 && (charCode < 48 || charCode > 57))
  //   ) {
  //     evt.preventDefault()
  //   } else {
  //     return true
  //   }
  // }

  public patchData(item, index, button) {
    if (
      this.stateTitle === false ||
      this.stateFreeText1 === false ||
      this.dateTimeexpired === null ||
      this.stateFreeText2 === false
    ) {
      return
    } else {
      const dataToEdit = {
        id: this.id,
        title: this.title,
        fileCode: this.freeText1 + '-' + this.freeText2,
        imageThumbnailId: this.imageThumbnailId.id,
        recommended: this.isRecommended,
        fileName: this.hasFiles.fileName,
        fileByte: this.hasFiles.fileByte,
        fileUpload: this.hasFiles.fileUpload,
        expireddate: this.dateTimeexpired,
      }
      trainingMaterialDataModule.updateTrainingMaterial(dataToEdit)
      this.$root.$emit('bv::hide::modal', this.postInfo.id, button)
    }
  }

  public base64Pdf(event) {
    const input = event.target
    if (input.files && input.files[0]) {
      const reader = new FileReader()
      reader.onload = (e: any) => {
        const hash = e.target.result.split(',')
        this.hasFiles = {
          fileName: input.files[0].name,
          fileByte: hash.length ? hash[1] : '',
          fileUpload: input.files[0],
        }
      }
      reader.readAsDataURL(input.files[0])
    }
  }

  public resetEditModal() {
    this.postInfo.title = ''
    this.postInfo.status = 'Active'
    this.postInfo.recomended = true
    this.postInfo.file = null
    this.postInfo.imageThumbnail = null
    this.postInfo.imageUrl = ''
    this.imageData = ''
    this.dateTimeexpired = ''
  }

  public modalDelete = {
    id: 'modal-delete',
    idData: 0,
    title: '',
  }
  public funcDelete(item, index, button) {
    if (this.$props.selected.length < 1) {
      this.modalDelete.idData = item.id
      this.modalDelete.title = item.title
      this.$root.$emit('bv::show::modal', this.modalDelete.id)
    }
  }
  public deleteNotif() {
    const ids = [this.modalDelete.idData]
    trainingMaterialDataModule.deleteTrainingMaterial({ ids })
    this.$root.$emit('bv::hide::modal', this.modalDelete.id)
  }

  public optionsRecomended = [
    { value: 'true', text: 'Yes' },
    { value: 'false', text: 'No' },
  ]
  public $refs!: {
    selectableTable: HTMLFormElement
  }
  public postInfo: any = {
    id: 'edit-notification',
    title: '',
    status: 'Active',
    recomended: true,
    file: null,
    imageThumbnail: null,
    imageUrl: '',
  }
  public imageData = ''
  public onRowSelected(items) {
    this.$emit('onRowSelected', items)
  }
  public selectAllRows() {
    if (this.$props.selected.length === this.dataTable.data.length) {
      this.$refs.selectableTable.clearSelected()
    } else {
      this.$refs.selectableTable.selectAllRows()
    }
  }

  public resetDeleteModal() {
    this.modalDelete.idData = 0
    this.modalDelete.title = ''
  }
  public get buttonDisable(): boolean {
    if (this.$props.selected.length < 1) {
      return false
    } else {
      return true
    }
  }

  public changeImageThumbnailId(item) {
    this.imageThumbnailId.id = item.id
    this.imageThumbnailId.link = item.link
  }
  public cancelImageThumbnailId() {
    this.imageThumbnailId.id = null
    this.imageThumbnailId.link =
      'http://www.ascendsolutions.ca/wp-content/uploads/2013/11/default-placeholder-1024x1024-700x500.png'
  }
}
